import { CustomElement } from '@aurelia/runtime-html';
export const name = "location-map-modal";
export const template = "<div class=\"modal-backdrop\" click.trigger=\"close()\"></div>\r\n<div class=\"modal modal--fullscreen location-map-modal\" role=\"dialog\" aria-modal=\"true\">\r\n  <div class=\"modal__header\">\r\n    <h2>${'collections.locationMapModal.title' | t: { title: collection.title }}</h2>\r\n    <button class=\"btn btn--icon modal__close\" click.trigger=\"close()\">&#10005;</button>\r\n  </div>\r\n  <div class=\"modal__body location-map-modal__body\">\r\n    <img class=\"location-map-modal__image\" src.bind=\"imageUrl\" alt=\"location map\">\r\n  </div>\r\n</div>\r\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
